import React, { useEffect } from 'react';
import { Root } from './style';

import { useState } from '@hookstate/core';

import { Link } from 'gatsby';

import Wallet from './Wallet';

import vars from 'variables';

const Sidebar = ({ location }) => {
  const page = useState('');
  const unfolded = useState(false);

  const toggle = () => {
    unfolded.set(!unfolded.get());
    document
      .getElementById('dashboard-layout')
      .querySelector('.over')
      .classList[unfolded.get() ? 'add' : 'remove']('open');
  };

  useEffect(() => {
    page.set(
      {
        '/dashboard': 'Overview',
        '/dashboard/rewards': 'BNB Rewards',
        '/dashboard/reinvestments': 'Reinvestments',
        '/dashboard/addresses': 'Key Addresses',
        '/dashboard/transactions': 'Transactions',
        '/dashboard/hodlers': 'Hodlers',
      }[location.pathname.replace(/\/$/, '')]
    );
  }, [location.pathname]);

  return (
    <Root className={unfolded.get() ? 'unfolded' : ''}>
      <div className="toggler" onClick={toggle}>
        {page.get()}
      </div>
      <Wallet />
      <ul>
        <li>
          <Link
            className="overview"
            to={vars.links.dashboard}
            activeClassName="active"
          >
            <span>Overview</span>
          </Link>
        </li>
        <li>
          <Link
            className="rewards"
            to={vars.links.dashboardrewards}
            activeClassName="active"
          >
            <span>BNB Rewards</span>
          </Link>
        </li>
        <li>
          <Link
            className="reinvestments"
            to={vars.links.dashboardreinvestments}
            activeClassName="active"
          >
            <span>Reinvestments</span>
          </Link>
        </li>
        <li>
          <Link
            className="transactions"
            to={vars.links.dashboardtransactions}
            activeClassName="active"
          >
            <span>Transactions</span>
          </Link>
        </li>
        <li>
          <Link
            className="hodlers"
            to={vars.links.dashboardhodlers}
            activeClassName="active"
          >
            <span>Hodlers</span>
          </Link>
        </li>
        <li>
          <Link
            className="addresses"
            to={vars.links.dashboardaddresses}
            activeClassName="active"
          >
            <span>Key Addresses</span>
          </Link>
        </li>
      </ul>
    </Root>
  );
};

export default Sidebar;
